export default __webpack_public_path__ + "static/media/Joyce_About_Me.a5156902.png";